module.exports = __webpack_public_path__ + "static/media/Alarm.3f6e2cc1.svg";